export default {
  GET_HISTORY: '@API_GET_HISTORY',
  GET_HISTORY_TRANSACTION: '@API_GET_HISTORY_TRANSACTION',
  GET_HISTORY_REDEMPTION: '@API_GET_HISTORY_REDEMPTION',
  CLEAR_HISTORY: 'CLEAR_HISTORY',
}
